/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { AuthService } from '@alfa-client/app-shared';
import { UserProfileResource, UserProfileService } from '@alfa-client/user-profile-shared';
import { Component, OnInit, inject } from '@angular/core';
import { StateResource } from '@common/tech-shared';
import { Observable } from 'rxjs';

@Component({
  selector: 'alfa-user-profile-in-header-container',
  templateUrl: './user-profile-in-header-container.component.html',
  standalone: false,
})
export class UserProfileInHeaderContainerComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly userProfileService = inject(UserProfileService);

  currentUserResource$: Observable<StateResource<UserProfileResource>>;
  meinProfilUrl$: Observable<string | undefined>;

  ngOnInit(): void {
    this.currentUserResource$ = this.userProfileService.getCurrentUser();
    this.meinProfilUrl$ = this.userProfileService.getMeinProfilUrl();
  }

  public logout(): void {
    this.authService.logout();
  }
}
